import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgWarningShield = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="m12.888 4.431-.221-.161-.22.161A7.07 7.07 0 0 1 6.6 5.61l-.707-.162v7.112a8.362 8.362 0 0 0 3.887 7.082l2.886 1.84 2.886-1.84a8.362 8.362 0 0 0 3.887-7.082V5.447l-.721.177a7.107 7.107 0 0 1-5.831-1.193Zm5.963 8.128a7.788 7.788 0 0 1-3.607 6.582l-2.577 1.634-2.577-1.634a7.754 7.754 0 0 1-3.607-6.582V6.184a7.62 7.62 0 0 0 6.184-1.193 7.676 7.676 0 0 0 6.184 1.193v6.375Z"
        fill="#374151"
      />
      <path
        d="M12.667 14.944c-.648 0-1.178.53-1.178 1.178 0 .648.53 1.178 1.178 1.178.648 0 1.178-.53 1.178-1.178 0-.648-.53-1.178-1.178-1.178Zm0 1.767a.59.59 0 0 1-.589-.589.59.59 0 0 1 .59-.589.59.59 0 0 1 .588.59.59.59 0 0 1-.589.588ZM11.93 14.355h1.473l.59-5.89h-2.651l.589 5.89Zm1.414-5.3-.47 4.711h-.413l-.471-4.711h1.354Z"
        fill="#374151"
      />
    </svg>
  );
};
export default SvgWarningShield;
